import connect from './connect'
import subscribe from './subscribe'
import unsubscribe from './unsubscribe'

export default {
	namespaced: true,
    state: {
		socket: null,
		queue: [],
		connecting: false,
		connected: false,
		connection: null
	},
    actions: {
		connect,
		subscribe,
		unsubscribe
	},
	mutations: {
		startConnecting(state) {
			state.connecting = true
		},
		finishConnecting(state) {
			state.connecting = false
		}
	}
}
